import type { ReactNode } from 'react';
import clsx from 'clsx';

interface StandardToolbarProps {
  left?: ReactNode;
  right?: ReactNode;
  className?: string;
}

/**
 * Toolbar row that sits between the page header and the table/grid.
 * Visual spec (OOM-1259): 56px tall, padding 0 24px, flex space-between.
 */
export function StandardToolbar({ left, right, className }: StandardToolbarProps): JSX.Element {
  return (
    <div
      className={clsx('flex items-center justify-between gap-3 px-6', className)}
      style={{ minHeight: 56 }}
    >
      <div className="flex items-center gap-2">{left}</div>
      <div className="flex items-center gap-2">{right}</div>
    </div>
  );
}
